export default {
  metadata: {
    version: '1.0.0',
    id: 'progress-bar-1.0.0',
    name: 'JDSProgressBar'
  },
  hierarchy: {
    container: [
      {
        'top-container': ['jds-text', 'value-jds-text']
      },
      {
        'determinate-container': ['active-container', 'invisible-container']
      },
      {
        'indeterminate-container': [
          'track-container',
          'active-animatedContainer'
        ]
      }
    ]
  },
  base: {
    container: {
      hidden: false,
      'flex-direction': '{p_0}',
      'justify-content': '{p_1}',
      'align-items': '{p_2}',
      gap: '{p_3}',
      width: '{p_4}',
      'background-color': '{p_5}'
    },
    'top-container': {
      hidden: false,
      show: false,
      'background-color': '{p_6}',
      'flex-direction': '{p_7}',
      'justify-content': '{p_8}',
      'align-items': '{p_9}',
      width: '{p_10}',
      gap: '{p_11}'
    },
    'determinate-container': {
      hidden: false,
      'background-color': '{p_12}',
      height: '{p_13}',
      width: '{p_14}',
      'flex-direction': '{p_15}',
      'justify-content': '{p_16}',
      'align-items': '{p_17}',
      'border-radius': '{p_18}'
    },
    'active-container': {
      'background-color': '{p_19}',
      height: '{p_20}',
      'border-radius': '{p_21}',
      show: true
    },
    'invisible-container': {
      height: '{p_22}',
      show: true
    },
    'indeterminate-container': {
      hidden: true,
      'flex-direction': '{p_23}',
      'background-color': '{p_24}',
      height: '{p_25}',
      width: '{p_26}',
      'border-radius': '{p_27}',
      overflow: 'hidden'
    },
    'track-container': {
      height: '{p_28}',
      show: true
    },
    'active-animatedContainer': {
      height: '{p_29}',
      width: '{p_30}',
      'background-color': '{p_31}',
      'z-index': 1,
      'border-radius': '{p_32}',
      'animation-curve': 'entrance_ease',
      'animation-duration': 1000
    },
    'jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    },
    'value-jds-text': {
      'font-family': '{text_137}',
      color: '{text_13}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    kind: {
      indeterminate: {
        'determinate-container': {
          hidden: true
        },
        'indeterminate-container': {
          hidden: false
        }
      }
    },
    state: {
      success: {
        'active-container': {
          'background-color': '{p_33}'
        },
        'active-animatedContainer': {
          'background-color': '{p_34}'
        }
      },
      error: {
        'active-container': {
          'background-color': '{p_35}'
        },
        'active-animatedContainer': {
          'background-color': '{p_36}'
        }
      },
      warning: {
        'active-container': {
          'background-color': '{p_37}'
        },
        'active-animatedContainer': {
          'background-color': '{p_38}'
        }
      }
    },
    labelPosition: {
      center: {
        'top-container': {
          'justify-content': '{p_39}'
        }
      }
    },
    _hasValueLabel: {
      false: {
        'value-jds-text': {
          hidden: true
        }
      }
    },
    _hasLabel: {
      false: {
        'jds-text': {
          hidden: true
        }
      }
    },
    _hasLabelOrValueLabel: {
      false: {
        'top-container': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      stretch: {
        false: {
          'top-container': {
            'justify-content': '{justifyContent.start}'
          },
          'value-jds-text': {
            hidden: true
          }
        }
      }
    },
    {
      stretch: {
        false: {
          'top-container': {
            'justify-content': '{justifyContent.end}'
          },
          'jds-text': {
            hidden: true
          }
        }
      }
    }
  ],
  combination_config: [
    ['labelPosition', '_hasValueLabel'],
    ['labelPosition', '_hasLabel']
  ],
  api: {
    data: {
      'active-container': {
        flex: {
          type: 'float',
          name: 'value',
          function: true,
          doc_description: 'It takes user input for value of progress bar.'
        }
      },
      'invisible-container': {
        flex: {
          type: 'float',
          name: '_invisible'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays the main label of Progess Bar.'
        }
      },
      'value-jds-text': {
        value: {
          type: 'string',
          name: 'valueLabel',
          doc_description: 'It displays the support label of Progess Bar.'
        }
      }
    },
    config: {
      kind: {
        values: ['determinate', 'indeterminate'],
        doc_description:
          'It can be used to switch between 2 variants of progess bar.'
      },
      labelPosition: {
        values: ['stretch', 'center'],
        doc_description:
          'It can be used align label of progress bar to center or at the ends of progress bar.'
      },
      state: {
        type: 'JDSFeedbackBlock.state',
        doc_description:
          "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'.This can be dynamically changed as per user's form handling.",
        values: ['none', 'success', 'error', 'warning']
      },
      _hasLabelOrValueLabel: {
        values: [true, false]
      },
      _hasLabel: {
        values: [true, false]
      },
      _hasValueLabel: {
        values: [true, false]
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'progressbar'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label',
            function: true
          },
          'aria-valuenow': {
            name: '_ariaValuenow',
            platform: 'web,ios'
          },
          'aria-valuemin': {
            name: '_ariaValuemin',
            platform: 'web,ios'
          },
          'aria-valuemax': {
            name: '_ariaValuemax',
            platform: 'web,ios'
          },
          'aria-busy': {
            name: 'ariaBusy',
            function: true
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
